import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=2b869a00&scoped=true&"
import script from "./AlertDialog.vue?vue&type=script&lang=js&"
export * from "./AlertDialog.vue?vue&type=script&lang=js&"
import style0 from "./AlertDialog.vue?vue&type=style&index=0&id=2b869a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b869a00",
  null
  
)

export default component.exports